import React from 'react';

import { Text, TextProps } from '@chakra-ui/react';

interface HelperProps extends TextProps {
    helper: string
}

export default function HelperMessage({
  helper,
  color,
  ...rest
}: HelperProps) {
  if (!helper) {
    return null;
  }
  return (
    <Text
      color={color}
      variant="smallSemiBold"
      {...rest}>{helper}
    </Text>
  );
}
